import { render, staticRenderFns } from "./ffc_hub.vue?vue&type=template&id=7237e738"
import script from "./ffc_hub.vue?vue&type=script&lang=js"
export * from "./ffc_hub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports